import { useEffect, useRef } from 'react';
import { Rect, Transformer, Circle } from 'react-konva';

const Box = ({ shapeProps, isSelected, onSelect, onChange }) => {
  const shapeRef = useRef();
  const trRef = useRef();

  useEffect(() => {
    if (isSelected) {
      // we need to attach transformer manually
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  return (
    <>
      {
        isSelected && (
        <Rect
          ref={ shapeRef }
          { ...shapeProps }
          fill={ isSelected ? 'rgba(0, 0, 0, 0.5)' : 'transparent' }
          draggable
          onDragStart={ onSelect }
          onDragEnd={ (e) => {
            onChange({
              ...shapeProps,
              x: e.target.x(),
              y: e.target.y(),
            });
          } }
          onTransformEnd={ (e) => {
            // transformer is changing scale of the node
            // and NOT its width or height
            // but in the store we have only width and height
            // to match the data better we will reset scale on transform end
            const node = shapeRef.current;
            const scaleX = node.scaleX();
            const scaleY = node.scaleY();

            // we will reset it back
            node.scaleX(1);
            node.scaleY(1);
            onChange({
              ...shapeProps,
              x: node.x(),
              y: node.y(),
              // set minimal value
              width: Math.max(5, node.width() * scaleX),
              height: Math.max(node.height() * scaleY),
            });
          } }
        />
        )
      }
      {
        !isSelected && (
        <Circle
          onClick={ onSelect }
          onTap={ onSelect }
          x={ shapeProps.x + shapeProps.width / 2 }
          y={ shapeProps.y + shapeProps.height / 2 }
          radius={ 20 }
          fill={ process.env.REACT_APP_PALETTE_SECONDARY_MAIN ?? '#00C98F' }
          stroke="black"
          strokeWidth={ 5 }
        />
        )
      }
      {isSelected && (
        <Transformer
          ref={ trRef }
          flipEnabled={ false }
          rotateEnabled={ false }
          boundBoxFunc={ (oldBox, newBox) => {
            // limit resize
            if (Math.abs(newBox.width) < 5 || Math.abs(newBox.height) < 5) {
              return oldBox;
            }
            return newBox;
          } }
        />
      )}
    </>
  );
};

export default Box;
